import { Form, Formik } from 'formik';
import { SolicitudGrupalForm } from './SolicitudGrupalForm';
import { AlertaError, AlertaExito } from 'utils/Alertas';
import Heading from 'components/design-system/Heading/Heading';
import gruposService from 'services/grupos';
import Text from 'components/design-system/Text/Text';

export const SolicitudGrupal = () => {
  return (
    <div className="bg-white rounded p-5 shadow-md mb-5">
      <Heading type="h4" className="mb-0">
        Enviar solicitud a un grupo de negocios
      </Heading>
      <Text className="mb-4">
        Puedes enviar invitaciones de administración a un grupo de negocios que
        hayas creado previamente
      </Text>
      <Formik
        initialValues={{
          grupo: null,
          listadoNegociosEnGrupo: null
        }}
        validateOnMount={true}
        onSubmit={async (values, { resetForm }) => {
          try {
            const params = {
              sucursales: null,
              empresa: null,
              grupo: { codigoGrupo: values.grupo.codigoGrupo },
              correosElectronicos: null
            };
            await gruposService.solicitarAdministracion(params).then(res => {
              if (res.status === 200 && !res.data.error) {
                AlertaExito('La solicitud ha sido enviada correctamente');
              }
            });
          } catch (error) {
            AlertaError('Ha ocurrido un error en el envío de la solicitud');
          } finally {
            resetForm();
          }
        }}
      >
        {({ values, isSubmitting, setFieldValue, handleChange }) => (
          <Form id="solicitud-grupal" onChange={event => {}}>
            <SolicitudGrupalForm
              isSubmitting={isSubmitting}
              setFieldValue={setFieldValue}
              values={values}
              handleChange={handleChange}
            />
          </Form>
        )}
      </Formik>
    </div>
  );
};
